import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const payUService = {
    getPayUPayments,
    getPaymentDetails,
    refundPayment
};

function getPayUPayments(data)
{
    return axios.get('/api/services/app/PayUPayment/GetPayUPayments', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}

function getPaymentDetails(orderId)
{
    return axios.get('/api/services/app/PayUPayment/GetPaymentDetails', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            orderId: orderId
        }
    })
}
function refundPayment(data)
{
    return axios.post('/api/services/app/PayUPayment/RefundPayment', data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}